var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadingWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Loading, Waiting.3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.383,
    height: 11.383
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5462",
    d: "M0 0h11.383v11.383H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5463",
    d: "M5.692 8.357v1.6",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5464",
    d: "M3.804 7.579L2.675 8.708",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5465",
    d: "M3.023 5.692h-1.6",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5466",
    d: "M2.675 2.675l1.129 1.129",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5467",
    d: "M5.692 2.846V1.423",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5468",
    d: "M7.954 3.429l.754-.754",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5469",
    d: "M9.96 5.692h-.711",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5470",
    d: "M8.708 8.708l-.251-.251",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgLoadingWaiting;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Loading-Waiting.svg
// module id = 804
// module chunks = 101